import './lighting/wled/wled_module';
import './hand_raiser_module';

import './phone_jam/phone_jam_module';
import './daw_interaction_module';
import './song_structures_dashboards/song_structures_dashboards_module';
import './ultimate_guitar/ultimate_guitar_module';
import './midi_playback/midi_playback_module';

import './dashboards/dashboards_module';
import './eventide/eventide_module';
import './song_structures/song_structures_module';
